<app-component-subnav></app-component-subnav>

<main *ngIf="standardparts">
  <h2>PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Normteile</h2>
  <clr-datagrid *ngIf="standardparts.length > 0" [clrDgLoading]="loading">
    <clr-dg-column [clrDgField]="'technical_drawing'">Zeichnungsnummer</clr-dg-column>
    <clr-dg-column [clrDgField]="'name'">Bezeichnung</clr-dg-column>
    <clr-dg-column [clrDgField]="'material'">Material</clr-dg-column>
    <clr-dg-column [clrDgField]="'weight'">Gewicht (in kg)</clr-dg-column>
    <clr-dg-column [clrDgField]="'description'">Kurzbeschreibung</clr-dg-column>
    <clr-dg-column [clrDgField]="'number_of_pieces_in_stock'">Lagerbestand (Warehouse)</clr-dg-column>
    <clr-dg-placeholder>We couldn't find any Technology!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let parts of standardparts" [routerLink]="['/component/details', parts.technical_drawing]">
      <clr-dg-cell>{{ parts.technical_drawing }}</clr-dg-cell>
      <clr-dg-cell><b>{{ parts.name }}</b></clr-dg-cell>
      <clr-dg-cell>{{ parts.material }}</clr-dg-cell>
      <clr-dg-cell>{{ parts.weight }}</clr-dg-cell>
      <clr-dg-cell>{{ parts.description }}</clr-dg-cell>
      <clr-dg-cell>{{ parts.number_of_pieces_in_stock }}</clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>
      <clr-dg-pagination #pagination [clrDgPageSize]="50">
        <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Normteile pro Seite</clr-dg-page-size>
        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
        von {{ standardparts.length }} Normteil(en)
      </clr-dg-pagination>
    </clr-dg-footer>
  </clr-datagrid>
</main>
